import { Textarea } from "@/components/ui/textarea";

interface ProcessItem { id: number; text: string; }
interface ProcessSectionProps { processes: ProcessItem[]; isEditing: boolean; onProcessUpdate: (id: number, text: string) => void; }

const ProcessSection = ({ processes, isEditing, onProcessUpdate }: ProcessSectionProps) => (
  <div>
    <h4 className="flex items-center text-accent font-medium mb-2">PROCESS<div className="flex-grow ml-2 h-px bg-accent/20"></div></h4>
    <ul className="space-y-2 py-2">
      {processes.map((p) => (
        <li key={p.id} className="flex items-start gap-2">
          <span className="text-muted-foreground">{p.id}.</span>
          {isEditing ? <Textarea value={p.text} onChange={(e) => onProcessUpdate(p.id, e.target.value)} className="flex-1 resize-none text-sm" onClick={(e) => e.stopPropagation()} /> : <span className="text-muted-foreground">{p.text}</span>}
        </li>
      ))}
    </ul>
  </div>
);

export default ProcessSection;
